import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { AdIndexService } from '../index.service';

export interface Ad {
  type: string;
  version: string;
  beacons: { type: string; url: string }[];
  bannerId: number;
  placementId: number;
  customization: { Teaser: string; Headline: string };
  title: string;
  description?: string;
  subtitle?: string;
  ctaText?: string;
  advertiser: string;
  rating: number;
  videos?: { width: number; height: number; url: string }[];
  images?: { width: number; height: number; url: string }[];
  clickUrl: string;
  refreshInterval: string;
}

@Injectable({
  providedIn: 'root',
})
export class cpDcService {
  private apiUrl = 'https://syn.nightlife.net/ads-api-native?key=3bcc77665d956674cec8c74570697d03&native_bs=20'; 
  private adsSubject = new BehaviorSubject<Ad[]>([]);
  ads$ = this.adsSubject.asObservable();

  constructor(private http: HttpClient, private adIndexService: AdIndexService) {}

  fetchAds(): Observable<Ad[]> {
    return this.http.get<Ad[]>(this.apiUrl).pipe(
      tap((ads) => {
        this.adsSubject.next(ads);
        this.adIndexService.resetIndex();
      })
    );
  }

  getAdByIndex(): Observable<Ad | null> {
    return this.ads$.pipe(
      map((ads) => {
        if (ads.length === 0) {
          return null;
        }

        let index = this.adIndexService.getCurrentIndex();
        
        if (index >= ads.length) {
          this.adIndexService.resetIndex();
          index = 0;
        }

        this.adIndexService.incrementIndex();
        //return ads[index];
        const randomIndex = Math.floor(Math.random() * ads.length);
        return ads[randomIndex];
      })
    );
  }

  recordImpression(url: any): Observable<any> {
    return this.http.get<any>(url);
  }

  getAdsWithVideos(): Observable<Ad[]> {
    return this.ads$.pipe(
      map((ads) => ads.filter(ad => ad.videos && ad.videos.length > 0))
    );
  }
}
